<template>
  <div class="collapsible-component">
    <v-expansion-panels focusable :multiple="multiple">
      <v-expansion-panel
        v-for="slot in slots"
        :key="slot.slot"
        class="rounded"
      >
        <v-expansion-panel-header>
          <template v-slot:actions>
            <v-icon class="icon">$expand</v-icon>
          </template>
          <v-row align="center" class="header">
            <v-col class="py-0 pl-2">
              <div>{{ slot.title }}</div>
            </v-col>
            <v-col class="button-col py-0">
              <slot :name="slot.slot + '.button'"></slot>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <slot :name="slot.slot"></slot>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>

export default {
  name: 'CollapsibleComponent',
  props: {
    slots: Array,
    multiple: {
      type: Boolean,
      default: false
    }
  },
  setup (_, { emit }) {

    function onEdit (slot) {
      emit('edit', slot)
    }

    function onSave (slot) {
      emit('save', slot)
    }

    function onDiscard (slot) {
      emit('discard', slot)
    }

    return {
      onEdit,
      onSave,
      onDiscard
    }
  }
}
</script>

<style scoped lang="scss">

.collapsible-component {
  .v-expansion-panel {
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.16);
    margin-top: 32px;

    &:first-child {
      margin-top: 0;
    }

    &::before,
    &::after {
      display: none;
    }

    // Style header
    .v-expansion-panel-header {
      font-weight: 500;

      .icon {
        order: 0;
      }

      .header {
        order: 1;
        width: 100%;
      }

      .button-col {
        display: none;
        text-align: right;
      }
    }

    // Change Icon position
    .v-icon {
      transform: rotate(-90deg);
    }

    // Change active state
    &--active {
      > .v-expansion-panel-header {
        // Change background on active state
        background-color: map-get($green, 'lighten-5');
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.16);

        // Change Icon position
        &--active .v-expansion-panel-header__icon .v-icon {
          transform: rotate(0);
        }

        // Remove default framework overlay bg-color
        &:before {
          display: none;
        }

        .button-col {
          display: block;
        }
      }
    }
  }
}
</style>
